const AdminCollaborator = () => {
  return (
    <div>
      <h1>Admin Collaborator</h1>
    </div>
  );
}

export default AdminCollaborator;